import React from "react";

// import mapWidgetValues from "./map-widget-values";

import WidgetCreate from "./widget-create";

interface Props {
  onClose?: any;
  onSuccess?: any;
  onError?: any;
  arrayHelpers?: any;
  fields?: any[];
}

function WidgetCreateContainer(props: Props) {
  const { onClose } = props;
  const defaultValues = {
    interval: {},
    layout: {
      x: 0,
      y: 0,
      width: 12,
      height: 12,
    },
  };
  // default values
  const entity = defaultValues;

  const { onSuccess /*, onError*/, arrayHelpers, fields = [] } = props;

  function nextSpot(width: number, height: number) {
    // TODO maxX may not be helpful in this context!
    let maxX = 0;
    let maxY = 0;
    fields.forEach((element) => {
      const l = element.layout;
      if (l) {
        maxX = Math.max(maxX, l.x + l.width);
        maxY = Math.max(maxY, l.y + l.height);
      }
    });
    // console.log("max ", [maxX, maxY]);
    return { x: 0, y: maxY };
  }

  /*async*/ function saveEntity(values: any) {
    if (arrayHelpers) {
      arrayHelpers.push(values);
    } else {
      console.error("arrayHelpers does not exist!");
      fields.push(values);
    }
    if (onSuccess) {
      onSuccess();
    }
    // return values;
  }

  return (
    <WidgetCreate
      saveEntity={saveEntity}
      cancelEdit={onClose}
      entity={entity}
      defaultValues={defaultValues}
      nextSpot={nextSpot}
    ></WidgetCreate>
  );
}

export default WidgetCreateContainer;
